(function($,window) {
    var employmentFormSelect = $("#employment-form");

    var hoursPerWeek = $("#hours-per-week");
    var selectDivs = employmentFormSelect.parent().siblings().andSelf();

    if (employmentFormSelect.attr('data-resize')) {
        if (employmentFormSelect.val() == "part_time") {
            if (selectDivs.hasClass('sales-profile')) {
                selectDivs.removeClass('col-md-6').addClass('col-md-4');
            } else {
                selectDivs.removeClass('col-md-3').addClass('col-md-4');
            }

            hoursPerWeek.show();
        } else {
            if (selectDivs.hasClass('sales-profile')) {
                selectDivs.removeClass('col-md-4').addClass('col-md-6');
            } else {
                selectDivs.removeClass('col-md-3').addClass('col-md-4');
            }

            hoursPerWeek.hide();
        }

        employmentFormSelect.on('change', toggleEmploymentFormSelect);
        employmentFormSelect.closest('form').on('templateload', toggleEmploymentFormSelect);

        function toggleEmploymentFormSelect() {
            if (employmentFormSelect.val() == "part_time") {
                if (selectDivs.hasClass('sales-profile')) {
                    selectDivs.removeClass('col-md-6').addClass('col-md-4');
                } else {
                    selectDivs.removeClass('col-md-3').addClass('col-md-4');
                }

                hoursPerWeek.show();
            } else {
                if (selectDivs.hasClass('sales-profile')) {
                    selectDivs.removeClass('col-md-4').addClass('col-md-6');
                } else {
                    selectDivs.removeClass('col-md-3').addClass('col-md-4');
                }

                hoursPerWeek.hide();
            }
        }
    } else {
        if (employmentFormSelect.val() == "part_time") {
            hoursPerWeek.show();
        } else {
            hoursPerWeek.hide();
        }

        employmentFormSelect.on('change', toggleEmploymentFormSelect);

        function toggleEmploymentFormSelect() {
            if (employmentFormSelect.val() == "part_time") {
                hoursPerWeek.show();
            } else  {
                hoursPerWeek.hide();
            }
        }
    }
})(jQuery,window);
